import React from 'react';
import useLmsContentFileUrl from '../../../hooks/useLmsContentFileUrl';

/**
 * The lesson's worksheet (`item`, its PDF content item), shown beside the drawing board so the
 * student can follow it while they draw. It loads through the Learning Zone file endpoint, like
 * Open PDF. Without a PDF it says the worksheet isn't uploaded yet, as Open PDF does.
 */
export default function ArtWorksheetPane({ item, title }) {
  const { url, loading, error } = useLmsContentFileUrl('learning-zone', item, { studentId: localStorage.getItem('userId') });

  let message = null;
  if (!item?.fileUrl) message = 'Worksheet not uploaded yet';
  else if (error) message = "This worksheet can't be opened right now. Please ask your teacher to upload it again.";
  else if (loading || !url) message = 'Loading worksheet...';

  return (
    <div className="flex flex-1 flex-col overflow-hidden rounded-xl border border-gray-200 bg-white shadow-sm">
      <div className="flex items-center gap-2 border-b border-gray-200 px-3 py-2">
        <span aria-hidden="true" className="rounded bg-red-500 px-1 py-0.5 text-[9px] font-black leading-none text-white">
          PDF
        </span>
        <span className="truncate text-sm font-extrabold text-slate-700">Worksheet</span>
      </div>

      {message ? (
        <div className="flex min-h-[420px] flex-1 flex-col items-center justify-center gap-2 bg-gray-50 p-6 text-center">
          <span className="mb-1 text-6xl leading-none" aria-hidden="true">
            🎨
          </span>
          <p className="text-base font-extrabold text-slate-700">{message}</p>
          {(!item?.fileUrl || error) && <p className="max-w-xs text-sm font-medium text-gray-500">You can still draw on the board!</p>}
        </div>
      ) : (
        <iframe src={url} title={`Worksheet: ${title}`} className="block min-h-[420px] w-full flex-1 bg-gray-100" />
      )}
    </div>
  );
}
